import pkg from '../package.json';
import {CONFIG_NAMESPACE} from './constants';
import Search from './views/search';
import SelectContentChange from './views/select-content-change';
import Multiselect from './views/multiselect';

const {$} = Voonto;

Voonto.ready.then((app) => {
  const config = app.lookup(CONFIG_NAMESPACE);

  $('[data-voc-sportsdata-search]').each(function() {new Search($(this), config);});
  $('[data-voc-sportsdata-select-content-change]').each(function() {new SelectContentChange($(this));});
  $('[data-voc-sportsdata-multiselect]').each(function() {new Multiselect($(this));});
});

export const VERSION = pkg.version;



// WEBPACK FOOTER //
// ./src/index.js